export const checkIntegrationSwitch = (enabledIntegrations: string, integration: string): boolean => {
  if (!enabledIntegrations || !integration) {
    return false
  }

  const config: Array<string> = enabledIntegrations.split(',')
  const isSwitchEnabled: boolean = config.includes(integration)

  return isSwitchEnabled
}
